import { createFileRoute, Navigate } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/deals/')({
	component: () => <Navigate to="/deals/active" />,
})
